const images = require.context("./img", true, /\.(svg|png)$/);
images.keys().forEach(images);
